// extracted by mini-css-extract-plugin
module.exports = {"welcome_placeholder":"WelcomeMessage_welcome_placeholder__2hOSj"};